export const is4xxClientError = statusCode => statusCode >= '400' && statusCode < '500';
export const is5xxServerError = statusCode => statusCode >= '500' && statusCode < '600';

export const is400BadRequest = statusCode => statusCode === '400';
export const is404NotFound = statusCode => statusCode === '404';
export const is500InternalServerError = statusCode => statusCode === '500';
